"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentInfosPackagesToJSON = exports.ShipmentInfosPackagesFromJSONTyped = exports.ShipmentInfosPackagesFromJSON = void 0;
var runtime_1 = require("../runtime");
function ShipmentInfosPackagesFromJSON(json) {
    return ShipmentInfosPackagesFromJSONTyped(json, false);
}
exports.ShipmentInfosPackagesFromJSON = ShipmentInfosPackagesFromJSON;
function ShipmentInfosPackagesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        '_package': json['package'],
        'forecast': !(0, runtime_1.exists)(json, 'forecast') ? undefined : json['forecast'],
        'trackingId': !(0, runtime_1.exists)(json, 'trackingId') ? undefined : json['trackingId'],
        'trackingUrl': !(0, runtime_1.exists)(json, 'trackingUrl') ? undefined : json['trackingUrl'],
        'desiredDeliveryUrl': !(0, runtime_1.exists)(json, 'desiredDeliveryUrl') ? undefined : json['desiredDeliveryUrl'],
        'isDelivered': !(0, runtime_1.exists)(json, 'isDelivered') ? undefined : json['isDelivered'],
    };
}
exports.ShipmentInfosPackagesFromJSONTyped = ShipmentInfosPackagesFromJSONTyped;
function ShipmentInfosPackagesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'package': value._package,
        'forecast': value.forecast,
        'trackingId': value.trackingId,
        'trackingUrl': value.trackingUrl,
        'desiredDeliveryUrl': value.desiredDeliveryUrl,
        'isDelivered': value.isDelivered,
    };
}
exports.ShipmentInfosPackagesToJSON = ShipmentInfosPackagesToJSON;
//# sourceMappingURL=ShipmentInfosPackages.js.map